import PropTypes from 'prop-types';
import React, { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import redux from '#/redux/modules';

import { isWorkstation } from '#/utils/componentStyleConfig';

const {
  scroll: {
    actions: { setScrolled },
  },
} = redux;

const SimpleScroll = ({ children, focusedElement }) => {
  const dispatch = useDispatch();

  const scrollHandler = useCallback(() => {
    // Update scroll axis with random number to trigger content loading, axis value deprecated
    dispatch(
      setScrolled({
        isScrolled: true,
        axis: Math.random(),
      }),
    );

    // Scroll the focused element into view on tv only
    if (!isWorkstation() && focusedElement) {
      focusedElement.scrollIntoView({ block: 'start' });
      // TODO: code to try if the above doesn't work
      // if(focusedElement.parentElement.parentElement.parentElement.scrollTop !== focusedElement.offsetTop) {
      //   console.log('cur offset: ' + focusedElement.parentElement.parentElement.parentElement.scrollTop);
      //   console.log('setting focus to: ' + focusedElement.offsetTop);
      //   focusedElement.parentElement.parentElement.parentElement.scrollTop = focusedElement.offsetTop;
      // }
    }
  }, [focusedElement]);

  useEffect(() => {
    scrollHandler();
  }, [focusedElement, scrollHandler]);

  return <div onScroll={scrollHandler}>{children}</div>;
};
SimpleScroll.propTypes = {
  children: PropTypes.node,
  focusedElement: PropTypes.object,
};

export default SimpleScroll;
